import { useContext, useEffect, useState } from 'react';
import { appContext } from '../../AppContext';
import LoadingDots from '../Animations/LoadingDots';
import HistoryPagination from './HistoryPagination';
import Search from '../shared/Search';
import TableHeader from './TableHeader';
import TableRows from './TableRows/TableRows';
import DeleteConfirmation from './DeleteConfirmation';
import axios from 'axios';
import { API } from '../../config/api';

//TODO: Add loading... for when SQL is slow to update
//TODO: Add logic for 0 search results when using filter functions.
const StampHistory = () => {
  const { files, setFiles, validatingFile, validationComplete } = useContext(appContext);

  const [data, setData] = useState<HistoryDetails[]>([]); // List of validated history
  const [history, setHistory] = useState<HistoryDetails[]>([]); // List of validated history
  const [totalPages, setTotalPages] = useState<number>(1);
  const [totalCount, setTotalCount] = useState<number>(1);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(8);
  const [sortColumn, setSortColumn] = useState('DATECREATED');
  const [sortOrder, setSortOrder] = useState('DESC');
  const [isSearching, setIsSearching] = useState(false);
  const [loading, setLoading] = useState(true);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  // useState<HistoryItem | null>
  const [itemToDelete, setItemToDelete] = useState<any | null>(null);

  // FIXME
  // add loading to sort etc
  // something wrong sorting file name
  // save sorting ?
  // should the page change?
  // search = no results

  // Update with history data from API
  const getHistory = async (): Promise<void> => {
    // setLoading(true); FIXME debounce

    try {
      const response = await axios.get(API.TIMESTAMP.pagination, {
        withCredentials: true,
        params: {
          limit: perPage,
          page: currentPage,
          sortColumn,
          sortOrder: sortOrder.toLowerCase(),
        },
      });

      setHistory(response.data.data);

      setTotalPages(response.data.totalPages);
      setTotalCount(response.data.totalRecords);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching history:', error);
      setLoading(false);
    }
  };
  useEffect(() => {
    getHistory();
  }, [files, validatingFile, validationComplete, currentPage, perPage, sortColumn, sortOrder]);

  useEffect(() => {
    setData(history);
  }, [history, files, sortColumn, sortOrder]);

  const handleDelete = (item) => {
    setItemToDelete(item);
    setDeleteModalOpen(true);
  };

  const deleteHistory = async (item) => {
    if (item) {
      try {
        await axios.delete(API.TIMESTAMP.delete(item.ID), {
          withCredentials: true,
        });
        // console.log('Records deleted successfully');
      } catch (error) {
        console.error(error);
      }

      setFiles((prevFiles) => prevFiles.filter((file) => file.fileHash !== item.HASH));
      setDeleteModalOpen(false);
    }
  };

  return (
    <div className="flex flex-col gap-6 w-full">
      <Search
        searchEndpoint={API.TIMESTAMP.search}
        setIsSearching={setIsSearching}
        setHistory={setHistory}
        setTotalCount={setTotalCount}
      />
      {!loading ? (
        data.length === 0 ? (
          <div className="flex justify-center items-center min-h-[320px] w-full">
            <div className="flex justify-center items-center w-[200px] h-[50px] m-4 border-dotted border-[1px] rounded-md">
              {isSearching ? 'No search results found.' : 'No user history recorded.'}
            </div>
          </div>
        ) : (
          <>
            <div className="w-full overflow-x-auto">
              <table className="table-fixed w-full min-w-[800px] border-separate border-spacing-y-2">
                <TableHeader
                  sortColumn={sortColumn}
                  setSortColumn={setSortColumn}
                  sortOrder={sortOrder}
                  setSortOrder={setSortOrder}
                />
                <TableRows data={data} getHistory={getHistory} handleDelete={handleDelete} />
              </table>
            </div>

            {deleteModalOpen && (
              <DeleteConfirmation
                setDeleteModalOpen={setDeleteModalOpen}
                itemToDelete={itemToDelete}
                deleteHistory={deleteHistory}
              />
            )}
            <HistoryPagination
              totalCount={totalCount}
              totalPages={totalPages}
              perPage={perPage}
              setPerPage={setPerPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          </>
        )
      ) : (
        <>
          <div className="flex flex-col items-center justify-center gap-2 w-full">
            <div className="h-[80px] w-[80px]">
              <LoadingDots spinningRadius={20} heightWidthPx={'64px'} />
            </div>
            <p className="text-xl font-normal text-core-grey-5">Loading...</p>
          </div>
        </>
      )}
    </div>
  );
};

export default StampHistory;
